const faPlus = {
  prefix: 'fal',
  iconName: 'plus',
  icon: [
    448,
    512,
    [],
    'f067',
    'M240 88c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H56c-8.8 0-16 7.2-16 16s7.2 16 16 16H208V424c0 8.8 7.2 16 16 16s16-7.2 16-16V272H392c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V88z',
  ],
};
export default faPlus;
